 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                : 'CruiseSheetBuild',
		pricing_method_input: null,
		pricing_row         : null,
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		form.pricing_method_input = $('#cruisesheetbuild-pricing_method');
		form.pricing_row          = $('#pricing_method_row');

		// When the itinerary changes, ajax request to see if we have a sabre_code for the itinerary. If it does, we give them an option of econnect.  If not, only manual pricing
		$("#cruisesheetbuild-itinerary_id").on("change", function itinChange() {
			pricingMethodCheck($(this));
		});

		$("#cruisesheetbuild-itinerary_id").on("ss.itinerary-prepopulated", function itinPre() {
			pricingMethodCheck($(this));
		});

		// hide the pricing method if the cruise line, ship, or sailing are changed
		$(".sailing-selection-cruise-line, .sailing-selection-ships, .sailing-selection-sailings").on("change", function itinChange() {
			hidePricingMethod();
		});

		$("#cruisesheetbuild-create_client").on("change", function itinChange() {
			var $self = $(this);

			if ($self.val() === '1') {
				$('#client-fields').removeClass('hidden');
			} else {
				$('#client-fields').addClass('hidden');
			}

		});

		// sets the pricing_method to "manual" and hides the field
		function hidePricingMethod()
		{
			// var $pricing_method_input = $('#cruisesheetbuild-pricing_method');
			form.pricing_method_input.val('manual');
			form.pricing_row.addClass('hidden');
		}

		/**
		 * If the itinerary selected has a sabre_code, we are going to show the pricing method drop-down and default it to eCONNECT
		 *
		 * @param  jQuery obj $itinerary_el  the element where the itinerary is selected
		 */
		function pricingMethodCheck($itinerary_el)
		{
			var url = '/Itineraries/econnectAllowed/' + $itinerary_el.val();

			Adzuki.Ajax.get(url).then(function success(response) {

				// we got a response of true, so we can show econnect option.  default to econnect in these cases
				if (response === true) {
					form.pricing_method_input.val('econnect');
					form.pricing_row.removeClass('hidden');
				} else {
					hidePricingMethod();
				}
			});
		}
	};

}(jQuery, window.Adzuki || {}));
